<template>
  <v-card flat>
    <v-card-text>
      <v-form
        v-if="employee"
        v-model="isFormValid">
        <v-text-field
          v-if="$can('edit', 'Employee')"
          v-model="employee.number"
          :error-messages="errorMessages.number"
          :label="$t('number')"
        />
        <v-text-field
          v-model="employee.first_name"
          :error-messages="errorMessages.first_name"
          :label="$t('firstName') + '*'"
          :rules="[$rules.isRequired]"
        />
        <v-text-field
          v-model="employee.last_name"
          :error-messages="errorMessages.last_name"
          :label="$t('lastName') + '*'"
          :rules="[$rules.isRequired]"
        />
        <v-text-field
          v-model="employee.nationality"
          :error-messages="errorMessages.nationality"
          :label="$t('nationality')"
        />
        <v-text-field
          v-model="employee.street"
          :error-messages="errorMessages.street"
          :label="$t('street')"
        />
        <select-city
          :value="employee.city"
          :error-messages="errorMessages.city"
          @input="city => employee.city = city"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <disabled-user-button>
        <v-btn
          slot-scope="{isDisabledForUser}"
          :loading="isLoading"
          :disabled="isDisabledForUser || isLoading || !isFormValid"
          color="primary"
          @click.native="editEmployee"
        >
          {{ $t('save') }}
        </v-btn>
      </disabled-user-button>

    </v-card-actions>
  </v-card>
</template>

<script>
import SelectCity from '@/components/global-components/inputs/SelectCity'
import { mapGetters, mapActions } from 'vuex'
import DisabledUserButton from '@/components/global-components/disabledUserButton/disabledUserButton'

export default {
  name: 'EmployeeSettingsPersonal',
  components: { DisabledUserButton, SelectCity },
  props: ['id'],
  data () {
    return {
      isFormValid: false,
      isLoading: false,
      employee: null,
      errorMessages: {}
    }
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee'])
  },
  methods: {
    ...mapActions('employee', ['saveEmployee']),
    async editEmployee () {
      if (!this.isFormValid) return

      try {
        this.isLoading = true
        await this.$notification(this.saveEmployee({
          employee: this.employee,
          companyId: this.currentEmployee.company_id
        }))
      } catch (e) {
        this.errorMessages = e
      }
      this.isLoading = false
    }
  },
  watch: {
    employee: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  },
  i18n: {
    messages: {
      en: {
        email: 'email',
        firstName: 'First name',
        lastName: 'Last name',
        nationality: 'Nationality',
        number: 'Employee number',
        save: 'Save personal settings',
        street: 'Street'
      },
      tr: {
        email: 'E-posta',
        firstName: 'İsim',
        lastName: 'Soyisim',
        nationality: 'Uyruk',
        number: 'Çalışan numarası',
        save: 'Kişisel ayarları kaydet',
        street: 'Sokak'
      },
      de: {
        email: 'E-Mail',
        firstName: 'Vorname',
        lastName: 'Nachname',
        nationality: 'Nationalität',
        number: 'Mitarbeiter Nummer',
        save: 'Speichern',
        street: 'Straße'
      },
      ru: {
        email: 'Эл. адрес',
        firstName: 'Имя',
        lastName: 'Фамилия',
        nationality: 'Национальность',
        number: 'Номер сотрудника',
        save: 'Сохранить персональные настройки',
        street: 'Улица'
      }
    }
  },
  created () {
    this.employee = Object.assign({}, this.currentEmployee)
  }
}
</script>
